import {
  useQuery,
  keepPreviousData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { fetchGetQuery, fetchDeleteQuery } from "../api";
import urlBuilder from "../../components/utils/dataGridURLBuilder";
import determineSorting from "../../components/utils/determineSorting";
// Custom hook to fetch paginated projects with sorting, searching and filtering
export function useGetProjectsPagination(
  pagination,
  sorting,
  search,
  columnFilters,
  endpoint = "Projekti/seznamProjektovPaginationV2",
) {
  const { pageIndex, pageSize } = pagination;

  // Determine sorting field and direction
  const { sortField, sortDirection } = determineSorting(sorting);

  // Filter out inactive filters (empty values)
  const activeFilters = columnFilters.filter((f) =>
    Array.isArray(f.value) ? f.value.length : f.value,
  );

  // Build URL with pagination, sorting, search and active filters
  const url = urlBuilder(
    endpoint,
    pagination,
    sortField,
    sortDirection,
    search,
    activeFilters,
  );

  return useQuery({
    queryKey: [
      "projects",
      endpoint,
      pageIndex,
      pageSize,
      sortField,
      sortDirection,
      search,
      columnFilters,
    ],
    queryFn: async () => {
      const result = await fetchGetQuery(url);
      return result;
    },
    placeholderData: keepPreviousData,
    retry: 0,
  });
}

//DELETE API call to delete project by id
export function useDeleteProject() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (idProject) => {
      return fetchDeleteQuery(`Projekti/${idProject}`);
    },
    onSuccess: () => {
      // Invalidate and refetch project list queries after successful delete
      queryClient.invalidateQueries({
        queryKey: ["projects"],
      });
    },
  });
}
